<template>
    <div class=" text-center text-22">
        <div v-if="type != 'surprise-box'" class=" flex-none text-gray-1">กดเพื่อใช้สิทธิ์</div>
        <div class=" underline text-a-blue-2929b4 break-normal" v-html="privilegeMsg"></div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "PrivilegeMessage",
    mixins: [LocaleMixin],
    props: {
        serialModel: Object,
        type: String
    },
    data: function() {
        return {
            privilegeMsg: "",
        };
    },
    created: function() {
        this.setPrivilegeMessage();
        console.log(this.serialModel)
    },
    methods: {
        setPrivilegeMessage: function() {
            if (this.isSetPrivilege()) {
                this.privilegeMsg ='<a href="' + this.serialModel.privilegeMessage + '" target="_blank">' + this.serialModel.privilegeMessage + '</a>';
            }
            // } else {
            //     this.privilegeMsg = this.lbl.serial.show_code_at_shop;
            // }
        },
        isSetPrivilege: function() {
            if (Util.isEmptyStr(this.serialModel.privilegeMessage)) {
                return false;
            }

            return this.serialModel.privilegeMessageFormat == "link" ? false : true;
        },
    },
}
</script>
